export const GET_PASSWORD_REQUIREMENTS_QUERY_KEY = [
  'password-requirements',
] as const;
